<template>
  <div v-if="canRateLunch" class="text-xs-center">
    <v-tooltip left>
      <v-btn slot="activator" icon @click="dialog = true">
        <v-badge color="info" right>
          <span slot="badge">!</span>
          <v-icon>rate_review</v-icon>
        </v-badge>
      </v-btn>
      <span v-t="'mainComponent.rateLunch'" />
    </v-tooltip>
    <rating-modal
      :dialog="dialog"
      :rated-dishes="ratedDishes"
      :date="dishesToRate.date"
      @closeRating="dialog = false"
      @saveRating="saveRating"
    />
  </div>
</template>

<script>
import { apolloClient } from '@/apollo';
import gql from 'graphql-tag';
import moment from 'moment';
import uniqBy from 'lodash/uniqBy';
import { mapState, mapActions } from 'vuex';
import RatingModalVue from '../../../common/rating-modal/RatingModal.vue';

export default {
  name: 'OrderRatingButton',
  components: {
    'rating-modal': RatingModalVue,
  },
  data() {
    return {
      dishesToRate: null,
      dishesToRateAndDay: null,
      ratedDishes: [],
      dialog: false,
      lunchTime: undefined,
    };
  },
  computed: {
    ...mapState('defaultValuesStore', ['dailyLunchStartHour', 'fridayLunchStartHour']),
    canRateLunch() {
      if (!this.dishesToRate || this.dishesToRate.dishes.filter(d => !d.alreadyRated).length === 0 || !this.dishesToRate.promptForRating) {
        return false;
      }
      const date = moment(this.dishesToRate.date);
      const today = moment();

      if (today.diff(date, 'days') >= 1 || today.get('hours') >= this.lunchTime) {
        this.$apollo.mutate({
          mutation: gql`mutation RemindedToRate($date: TimelessDate!) {
            remindedToRate(date: $date)
          }`,
          variables: {
            date: this.dishesToRate.date,
          },
        });
        return true;
      }

      return false;
    },
  },
  watch: {
    dishesToRateAndDay(newValue) {
      const { dishesToRate, day } = newValue;
      this.dishesToRate = dishesToRate;
      if (this.dishesToRate.dishes.length > 0) {
        this.dialog = this.dishesToRate.promptForRating;
        this.ratedDishes = uniqBy(this.dishesToRate.dishes, 'title').filter(d => !d.alreadyRated)
          .map(d => ({
            id: d.id,
            rating: null,
            comment: '',
            title: d.title,
            isSoup: d.isSoup,
          }));
        this.lunchTime = day.isFreeOfCharge ? this.fridayLunchStartHour : this.dailyLunchStartHour;
      }
    },
  },
  async mounted() {
    await this.loadDefaultValues();
  },
  methods: {
    ...mapActions('defaultValuesStore', ['loadDefaultValues']),
    async saveRating() {
      this.dialog = false;
      await apolloClient.mutate({
        mutation: gql`mutation SaveDishesRating($data: [DishRatingInput]!){
          rateDishes(data: $data)
        }`,
        variables: {
          data: this.ratedDishes.map(d => ({
            dishId: d.id,
            rating: d.rating,
            comment: d.comment,
          })),
        },
      });
      await this.$apollo.queries.dishesToRate.refresh();
    },
  },
  apollo: {
    dishesToRateAndDay: {
      fetchPolicy: 'network-only',
      query: gql`query DishesToRateQuery($date: TimelessDate!){
        dishesToRate {
          date
          promptForRating
          dishes {
            id
            isSoup
            title
            providerId
            alreadyRated
          }
        }
        day(date: $date) {
          isFreeOfCharge
        }
      }`,
      variables() {
        return {
          date: moment.utc().format('YYYY-MM-DD'),
        };
      },
      update: data => data,
    },
  },
};
</script>
